import { useMatch } from "react-router-dom";

const usePageMatch = (page: string) => {
    const match = useMatch(page);
    const isOnPage = match?.pathname === page;

    return isOnPage;
};

export default usePageMatch;